export default track => (target, data) => {
  const startTime = new Date().getTime();

  function mouseleave() {
    const hoverTime = new Date().getTime() - startTime;
    const {
      eventValue: { hoverTimeThreshold = 1500 }
    } = data;

    // track only if a minimum hover time is exceeded
    if (hoverTime > hoverTimeThreshold) {
      Object.assign(data.eventValue, { hoverTime });
      track(data);
    }

    target.removeEventListener('mouseleave', mouseleave);
  }

  target.addEventListener('mouseleave', mouseleave);
};
